import { Component } from '@angular/core';

@Component({
  selector: 'app-cli',
  standalone: false,
  templateUrl: './cli.component.html',
  styleUrls: ['./cli.component.css']
})
export class CliComponent {

  constructor() { }

}
